import Icon from "@/components/Icon"
import { useI18n } from "@/helpers/i18n"

export function InvalidConfigView() {
  const { t, tMap } = useI18n()

  return (
    <div
      className="flex size-full flex-col items-center gap-y-6 px-8 pt-36 pb-8"
      data-unmask
    >
      <Icon name="alert" size="xl" className="text-danger-200" />
      <div className="flex flex-col gap-y-2 text-center text-neutral-700">
        <h1 className="font-h1-bold">
          {t("callPanel.invalidAgentConfig.title")}
        </h1>
        <div>
          {tMap("callPanel.invalidAgentConfig.description", (text, i) => (
            <p key={i} className="font-body-large-regular">
              {text}
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}
